<template>
  <div class="dashboard background">
    <date-picker v-model="startPayDate"
      element="startPayDate"></date-picker>
    <date-picker v-model="startDate"
      element="startDate"></date-picker>
    <date-picker
      v-model="endDate"
      element="endDate"></date-picker>
    <date-picker
      v-model="payDate"
      element="payDate"></date-picker>
    <toast />
    <dashboard-page pcontent="1" page="COURSES">
      <!-- course manager  -->
      <card w='80%' minWidth='950px' v-if='true'>
        <!-- card header -->
        <div class='fRow fullWidth jStart aCenter'>
          <div class='growFull fCol jStart aStart'>
            <h3 class='growFull text-right'>مدیریت تفاهم نامه‌ها</h3>
            <p class='note'>تفاهم نامه‌ها را ایجاد و ویرایش کنید.
            </p>
          </div>
          <btn isMini='true' label='به‌روز رسانی' bc='#667089'
            style="margin: 8px !important;"
            v-if="false"
            icon='keyboard_arrow_left' @click.native="backToCourse"/>
        </div>
        <div class="tabHeader fRow jStart aCenter fullWidth" id="tab">
          <a @click="toggleSection('form')"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: isAssignment}">
            <i class="material-icons-round transition-fast">
              {{editMode ? 'edit_note' : 'assignment_turned_in'}}
            </i>
            <span class="transition-fast">
              {{editMode ? `ویرایش ${editData.fullName}` : 'ایجاد تفاهم نامه'}}
            </span>
          </a>
          <a @click="toggleSection('students')"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: isStudents}">
            <i class="material-icons-round transition-fast">reorder</i>
            <span class="transition-fast">لیست دانش‌آموزان</span>
          </a>
          <a @click="toggleSection('convention')"
            v-if="false"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: isConvention}">
            <i class="material-icons-round transition-fast">support_agent</i>
            <span class="transition-fast">مشاور</span>
          </a>
          <div class="fRow jEnd aCenter growFull">
            <div class="b fRow jCenter aCenter active">
              <i class="material-icons-round">get_app</i>
              <label>دریافت فایل اکسل تفاهم نامه‌ها</label>
            </div>
          </div>
        </div>
        <!-- صفحه اضافه کردن تفاهم نامه -->
        <div class="uploadersHolder fRow jBetween aCenter wrap fullWidth"
          v-if='isAssignment'>
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3 class="fRow jBetween aCenter">
              {{editMode ? `اطلاعات ${editData.fullName} را مشاهده و در صورت تمایل ویرایش کنید`
                : 'برای ایجاد تفاهم نامۀ جدید فرم زیر را پر کنید'}}
              <div class="b fRow jStart aCenter"
                v-if="editMode"
                @click="toggleSection('students')">
                <i class="material-icons-round">close</i>
                <label>بستن و مشاهدۀ دانش‌آموزان</label>
              </div>
            </h3>
            <div class="ruleBox fCol jStart aStart w50">
              <h4>تکمیل تمامی موارد الزامی می‌باشد.</h4>
            </div>
          </div>
          <div class="fRow jBetween aStart fulWidth assignmentForm">
            <!-- فرم تفاهم نامه -->
            <div class="fullWidth fRow jBetween aCenter wrap">
              <h4 class="fullWidth">انتخاب مؤسسه</h4>
              <div class="fullWidth fRow jStart aStart companies">
                <div class="loadingInstitutes"
                  v-if="company.length === 0">در حال دریافت مؤسسه‌ها...</div>
                <div class="company fRow jStart aCenter transition-fast"
                  v-for="(item, index) in company" v-bind:key="index"
                  @click="selectedCompany = item.id"
                  v-bind:class="{selected: selectedCompany === item.id}">
                  <i class="check material-icons-round">
                    {{selectedCompany !== item.id
                      ? 'radio_button_unchecked' : 'task_alt'}}
                  </i>
                  <div class="fCol jCenter aStart">
                    <span>مؤسسه</span>
                    <div class="companyName">{{item.title}}</div>
                  </div>
                </div>
              </div>
              <h4 class="fullWidth"
                style="margin-top: 16px">وضعیت قرارداد</h4>
              <switch-button :val="assignmentStatus"
                style="margin-bottom: 16px"
                @click.native="assignmentStatus = !assignmentStatus"
                activeLabel="فعال"
                deactiveLabel="غیرفعال" />
              <h4 class="fullWidth">مشخصات دانش آموز</h4>
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: nameErr}">account_circle</i>
                  نام - {{name.length}}/24</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="نام"
                    type="text" v-model="name">
                </div>
              </div>
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: lastNameErr}">account_circle</i>
                  نام خانوادگی - {{lastName.length}}/24</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="نام خانوادگی"
                    type="text" v-model="lastName">
                </div>
              </div>
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: melliErr}">fingerprint</i>
                  کد ملی - {{melli.length}}/10</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="کد ملی"
                    type="number" v-model="melli">
                </div>
              </div>
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: studentPhoneErr}">phone_iphone</i>
                  شماره همراه - {{studentPhone.length}}/11</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="شماره همراه"
                    type="number" v-model="studentPhone">
                </div>
              </div>
              <h4 class="fullWidth">مشخصات والدین</h4>
              <!-- پدر -->
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: fatherErr}">man</i>
                  نام پدر - {{father.length}}/40</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="نام پدر"
                    type="text" v-model="father">
                </div>
              </div>
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: fatherEduErr}">school</i>
                  تحصیلات پدر - {{fatherEdu.length}}/40</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="تحصیلات پدر"
                    type="text" v-model="fatherEdu">
                </div>
              </div>
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: fatherJobErr}">work_outline</i>
                  شغل پدر - {{fatherJob.length}}/40</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="شغل پدر"
                    type="text" v-model="fatherJob">
                </div>
              </div>
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: fatherPhoneErr}">phone_iphone</i>
                  شماره تماس پدر - {{fatherPhone.length}}/11</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="شماره تماس پدر"
                    type="number" v-model="fatherPhone">
                </div>
              </div>
              <!-- مادر -->
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: motherErr}">woman</i>
                  نام مادر - {{mother.length}}/40</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="نام مادر"
                    type="text" v-model="mother">
                </div>
              </div>
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: motherEduErr}">school</i>
                  تحصیلات مادر - {{motherEdu.length}}/40</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="تحصیلات مادر"
                    type="text" v-model="motherEdu">
                </div>
              </div>
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: motherJobErr}">work_outline</i>
                  شغل مادر - {{motherJob.length}}/40</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="شغل مادر"
                    type="text" v-model="motherJob">
                </div>
              </div>
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: motherPhoneErr}">phone_iphone</i>
                  شماره تماس مادر - {{motherPhone.length}}/11</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="شماره تماس مادر"
                    type="number" v-model="motherPhone">
                </div>
              </div>
              <h4 class="fullWidth">سایر اطلاعات</h4>
              <div class="w20 fCol jStart aStart inputHolder"
                v-if="!editMode || (editMode && letEditDropDowns)">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: fieldErr}">category</i>
                  انتخاب رشته</span>
                  <cool-select
                    class="fullWidth"
                    @select="selected($event, 'field')"
                    v-model="field"
                    disable-search
                    :items="fields"
                    :item-value="fields.id"
                    :item-text="fields.title">
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: fields }">
                      <div style="display: flex; align-items: center;">
                        <div>
                          {{ fields.title }}
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text field) -->
                    <template slot="selection" slot-scope="{ item: fields }">
                      <div>
                        {{ fields.title }}
                      </div>
                    </template>
                  </cool-select>
              </div>
              <div class="w20 fCol jStart aStart inputHolder"
                v-if="!editMode || (editMode && letEditDropDowns)">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: gradeErr}">category</i>
                  انتخاب پایه‌ی تحصیلی</span>
                  <cool-select
                    class="fullWidth"
                    @select="selected($event, 'grade')"
                    v-model="grade"
                    disable-search
                    :items="grades"
                    :item-value="grades.id"
                    :item-text="grades.title">
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: grades }">
                      <div style="display: flex; align-items: center;">
                        <div>
                          {{ grades.title }}
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text grade) -->
                    <template slot="selection" slot-scope="{ item: grades }">
                      <div>
                        {{ grades.title }}
                      </div>
                    </template>
                  </cool-select>
              </div>
              <div class="w20 fCol jStart aStart inputHolder"
                v-if="!editMode || (editMode && letEditDropDowns)">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: planErr}">subject</i>
                  انتخاب پلن</span>
                  <cool-select
                    class="fullWidth"
                    @select="selected($event, 'plan')"
                    v-model="plan"
                    disable-search
                    :items="plans"
                    :item-value="plans.id"
                    :item-text="plans.title">
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: plans }">
                      <div style="display: flex; align-items: center;">
                        <div>
                          {{ plans.title }}
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text field) -->
                    <template slot="selection" slot-scope="{ item: plans }">
                      <div>
                        {{ plans.title }}
                      </div>
                    </template>
                  </cool-select>
              </div>
              <div class="w60 fRow jBetween aCenter fieldsPreview"
                v-if="editMode && !letEditDropDowns">
                <div class="fCol jCenter aStart w25">
                  <div class="mini">رشته</div>
                  <div class="t">{{editData.field.title}}</div>
                </div>
                <div class="fCol jCenter aStart w25">
                  <div class="mini">پایۀ تحصیلی</div>
                  <div class="t">{{editData.grade.title}}</div>
                </div>
                <div class="fCol jCenter aStart w25">
                  <div class="mini">پلن انتخابی</div>
                  <div class="t">{{editData.planType}}</div>
                </div>
                <div class="b fRow jCenter aCenter" @click="letEditDropDowns = true">
                  <i class="material-icons-round">edit</i>
                  <label>ویرایش</label>
                </div>
              </div>
              <div class="w20 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: stErr}">date_range</i>
                  شروع قرارداد</span>
                <div class="fRow jStart aCenter fullWidth inputWraper"
                  style="margin-bottom: 0;">
                  <input @keyup.enter="newAssignment" id="startDate"
                    disabled
                    class="transition-fast" placeholder="شروع قرارداد"
                    type="text" v-model="startDateShow">
                </div>
              </div>
              <div class="w20 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: etErr}">date_range</i>
                  پایان قرارداد</span>
                <div class="fRow jStart aCenter fullWidth inputWraper"
                  style="margin-bottom: 0;">
                  <input @keyup.enter="newAssignment" id="endDate"
                    disabled
                    class="transition-fast" placeholder="پایان قرارداد"
                    type="text" v-model="endDateShow">
                </div>
              </div>
              <!-- moshaver -->
              <div class="fullWidth fCol jStart aStart inputHolder"
                style="min-height: 480px; margin-top: 16px">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: selectedConsultants.length < 1}">account_circle</i>
                  انتخاب مشاور
                </span>
                <cool-select
                  class="fullWidth"
                  v-if="false"
                  @select="selected($event, 'convention')"
                  v-model="convention"
                  :items="conventions"
                  :item-value="conventions.id"
                  :item-text="conventions.title">
                  <!-- slot for each item in the menu -->
                  <template slot="item" slot-scope="{ item: conventions }">
                    <div style="display: flex; align-items: center;">
                      <div>
                        {{ conventions.title }}
                      </div>
                    </div>
                  </template>
                  <!-- slot for the selected item (in the text field) -->
                  <template slot="selection" slot-scope="{ item: conventions }">
                    <div>
                      {{ conventions.title }}
                    </div>
                  </template>
                </cool-select>
                <div class="fullWidth fRow jBetween aStart consultantHolder wrap">
                  <div class="fullWidth fRow jStart aStart header wrap">
                    <span class="t">مشاور را انتخاب کنید:</span>
                    <div class="filters fRow jStart aCenter">
                      <span class="o">نمایش</span>
                      <div class="cheap transition-medium"
                        @click="consultantFilter = 0"
                        v-bind:class="{
                          selected: consultantFilter === 0,
                        }">همه‌ی مشاورین</div>
                      <div class="cheap transition-medium"
                        @click="consultantFilter = 2"
                        v-bind:class="{
                          selected: consultantFilter === 2,
                        }">مشاورین جذب</div>
                      <div class="cheap transition-medium"
                        @click="consultantFilter = 1"
                        v-bind:class="{
                          selected: consultantFilter === 1,
                        }">مشاورین آموزشی</div>
                    </div>
                    <input type="text" class="search fullWidth"
                      placeholder="نام مشاور را جستجو کنید"
                      v-model="consultantSearch">
                  </div>
                  <div class="items w60 fRow jBetween aCenter wrap">
                    <h2 class="fullWidth"
                      v-if="filteredConsultants.length !== 0">مشاورها را انتخاب کنید
                      ({{filteredConsultants.length}} مشاور)
                    </h2>
                    <div class="item fRow jStart aCenter w50 transition-fast"
                      @click="selectConsultant(item.id)"
                      v-bind:class="{
                        selectedItem: selectedConsultants.includes(item.id),
                        gone: consultantFilter !== item.type && consultantFilter !== 0,
                      }"
                      v-for="(item, index) in filteredConsultants" v-bind:key="index">
                      <i class="check material-icons-round">
                        {{!selectedConsultants.includes(item.id)
                          ? 'radio_button_unchecked' : 'task_alt'}}
                      </i>
                      <span class="name growFull">{{item.title}}</span>
                      <span class="type">{{item.type === 2 ? 'مشاور جذب' : 'مشاور آموزشی'}}</span>
                    </div>
                    <div class="noResult fCol fullWidth jCenter aCenter"
                      v-if="filteredConsultants.length === 0">
                      <i class="material-icons-round">error</i>
                      <span>نتیجه‌ای یافت نشد</span>
                      <div class="mini" @click="consultantSearch = ''">حذف فیلتر</div>
                    </div>
                  </div>
                  <div class="selectedItems w40 fCol jStart aCenter">
                    <h2 class="fullWidth">مشاورین انتخاب شده:</h2>
                    <div class="item fRow jStart aCenter fullWidth transition-fast"
                      v-for="(item, index) in selectedItems" v-bind:key="index">
                      <span class="index">{{index + 1}}</span>
                      <span class="name growFull">{{item.title}}</span>
                      <span class="type">{{item.type === 2 ? 'مشاور جذب' : 'مشاور آموزشی'}}</span>
                      <i class="ac material-icons-round"
                        @click="deleteConsultant(item.id)">delete</i>
                    </div>
                    <div class="noResult fCol fullWidth jCenter aCenter"
                      v-if="selectedItems.length === 0">
                      <i class="material-icons-round">error</i>
                      <span>هیچ مشاوری انتخاب نشده</span>
                      <!-- <div class="mini"></div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="fullWidth fCol jStart aStart inputHolder" style="min-height: 480px">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: selectedClasses.length < 1}">account_circle</i>
                  انتخاب کلاس‌ها
                </span>
                <div class="fullWidth fRow jBetween aStart consultantHolder wrap">
                  <div class="fullWidth fRow jStart aStart header wrap">
                    <span class="t">نام درس برای کلاس را انتخاب کنید:</span>
                    <input type="text" class="search fullWidth"
                      placeholder="نام کلاس را جستجو کنید"
                      v-model="classSearch">
                  </div>
                  <div class="items w60 fRow jBetween aCenter wrap">
                    <h2 class="fullWidth"
                      v-if="filteredClasses.length !== 0">کلاس ها را انتخاب کنید
                      از بین ({{filteredClasses.length}} کلاس)
                    </h2>
                    <div class="item fRow jStart aCenter w50 transition-fast"
                      @click="selectClass(item.id)"
                      v-bind:class="{
                        selectedItem: selectedClasses.includes(item.id)
                      }"
                      v-for="(item, index) in filteredClasses" v-bind:key="index">
                      <i class="check material-icons-round">
                        {{!selectedClasses.includes(item.id)
                          ? 'radio_button_unchecked' : 'task_alt'}}
                      </i>
                      <span class="name growFull">کلاس {{item.title}}</span>
                    </div>
                    <div class="noResult fCol fullWidth jCenter aCenter"
                      v-if="filteredClasses.length === 0">
                      <i class="material-icons-round">error</i>
                      <span>نتیجه‌ای یافت نشد</span>
                      <div class="mini" @click="classSearch = ''">حذف فیلتر</div>
                    </div>
                  </div>
                  <div class="selectedItems w40 fCol jStart aCenter">
                    <h2 class="fullWidth">کلاس های انتخاب شده:</h2>
                    <div class="item fRow jStart aCenter fullWidth transition-fast"
                      v-for="(item, index) in selectedClassItems" v-bind:key="index">
                      <span class="index">{{index + 1}}</span>
                      <span class="name growFull">{{item.title}}</span>
                      <i class="ac material-icons-round"
                        @click="deleteClass(item.id)">delete</i>
                    </div>
                    <div class="noResult fCol fullWidth jCenter aCenter"
                      v-if="selectedClassItems.length === 0">
                      <i class="material-icons-round">error</i>
                      <span>هیچ کلاسی انتخاب نشده</span>
                      <!-- <div class="mini"></div> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- pardakht -->
              <div class="fullWidth fCol jStart aCenter" v-if="true">
                <h4 class="fullWidth">آیتم های پرداخت</h4>
                <div class="fullWidth fRow jStart aCenter wrap" style="padding: 0 8px 8px 8px">
                  <div class="ti fullWidth jStart aCenter">ابتدا نحوه‌ی پرداخت را انتخاب کنید</div>
                  <radio
                    v-for="(item, index) in payTypes" v-bind:key="index"
                    :simple="true"
                    :data="item"
                    style="padding-left: 24px"
                    :selected="item.id === payType.id"
                    @click.native="payType = item" />
                </div>
                <div class="fullWidth fRow jBetween aCenter"
                  v-if="true"
                  style="margin: 16px 0">
                  <div class="w40 fCol jStart aStart inputHolder" v-if="payType.id > 0">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round"
                        v-bind:class="{inpErr: amountErr}">flag</i>
                      مبلغ کل قرارداد (تومان)</span>
                    <div class="fRow jStart aCenter fullWidth inputWraper">
                      <input class="transition-fast" placeholder="مبلغ کل قرارداد (تومان)"
                        type="text" v-model="amount">
                    </div>
                  </div>
                  <div class="w40 fCol jStart aStart inputHolder" v-if="payType.id > 1">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round"
                        v-bind:class="{inpErr: qestAmountErr}">flag</i>
                      مبلغ هر قسط (تومان)</span>
                    <div class="fRow jStart aCenter fullWidth inputWraper">
                      <input class="transition-fast" placeholder="مبلغ هر قسط (تومان)"
                        type="text" v-model="qestAmount">
                    </div>
                  </div>
                  <div class="w20 fCol jStart aStart inputHolder" v-if="payType.id > 1">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round"
                        v-bind:class="{inpErr: stpErr}">date_range</i>
                      تاریخ اولین قسط</span>
                    <div class="fRow jStart aCenter fullWidth inputWraper">
                      <input id="startPayDate"
                        disabled
                        class="transition-fast" placeholder="تاریخ اولین قسط"
                        type="text" v-model="startPayDateShow">
                    </div>
                  </div>
                </div>
                <div class="fCol jStart aCenter fullWidth" v-if="!editMode">
                  <pay-item
                    v-for="(item, index) in payItemArray" v-bind:key="index"
                    :i="index"
                    from="assignment"
                    @addNew="addNewPayItem"
                    @delete="deleteFromArray($event)"
                    @payItemChanged="itemChanged($event)"
                    @result="getResult($event)"/>
                  <div class="fullWidth fRow jEnd aCenter">
                    <div class="b fRow jStart aCenter active"
                      @click="addNewPayItem"
                      style="margin: 12px 16px 0 0;">
                      <i class="material-icons-round">add</i>
                      <label>اضافه کردن آیتم پرداخت بعدی</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fRow jStart aCenter fullWidth">
            <div class="b fRow jStart aCenter big"
              @click="newStudent" v-if="!editMode"
              v-bind:class="{active: isFormReady, disable: loading}">
              <i class="material-icons-round">{{!loading ? 'done_all' : 'hourglass_top'}}</i>
              <label>{{!loading ? 'ثبت تفاهم‌نامه جدید' : 'لطفا صبر کنید...'}}</label>
            </div>
            <div class="b fRow jStart aCenter mini"
              v-if="!editMode"
              @click="clearStudentForm">
              <i class="material-icons-round">delete</i>
              <label>پاک کردن فرم</label>
            </div>
            <div class="b fRow jStart aCenter big"
              @click="editStudent" v-if="editMode"
              v-bind:class="{active: isEditFormReady}">
              <i class="material-icons-round">edit</i>
              <label>ویرایش تفاهم نامه</label>
            </div>
            <div class="b fRow jStart aCenter mini"
              v-if="editMode"
              @click="clearStudentForm">
              <i class="material-icons-round">close</i>
              <label>انصراف</label>
            </div>
          </div>
        </div>
        <!-- صفحه لیست دانش آموزان -->
        <div class="uploadersHolder fRow jBetween aCenter wrap fullWidth"
          v-if='isStudents'>
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>دانش‌آموزان را مشاهده و ویرایش کنید.</h3>
          </div>
          <!-- export -->
          <div class="fullWidth fRow jStart aStart wrap sorts export"
            style="margin-bottom: 32px">
            <div class="fullWidth fRow jStart aCenter head">
              <i class="material-icons-round">get_app</i>
              <span>دانلود اکسل تفاهم‌نامه ها</span>
            </div>
            <div class="fRow jStart aCenter growFull">
              <radio
                v-for="(item, index) in exportFiltersArray" v-bind:key="index"
                :simple="true"
                :data="item"
                :checkbox="true"
                style="padding-left: 24px"
                :selected="exportFilters.indexOf(item.id) !== -1"
                @click.native="selectExportFilter(item.id)" />
            </div>
            <div class="b fRow jCenter aCenter">
              <i class="material-icons-round">get_app</i>
              <label>ثبت درخواست</label>
            </div>
          </div>
          <!-- filter -->
          <div class="fullWidth fRow jStart aStart wrap sorts"
            style="margin-bottom: 32px">
            <div class="fullWidth fRow jStart aCenter head">
              <i class="material-icons-round">sort</i>
              <span>مرتب سازی بر اساس</span>
            </div>
            <radio
              v-for="(item, index) in studentsSorts" v-bind:key="index"
              :simple="true"
              :data="item"
              style="padding-left: 24px"
              :selected="item.id === studentsSort.id"
              @click.native="studentsSort = item" />
          </div>
          <div class="fRow jStart aCenter fullWidth" style="margin: 0 0 16px 0">
            <input type="text"
              v-model="studentSearch"
              @keypress.enter="handleGetStudent"
              class="growFull"
              style="margin-left: 16px"
              placeholder="جستجو کنید">
            <div class="fRow jBetween aCenter"
              v-if="true"
              @click="activeStudents = !activeStudents"
              style="width: 358px">
              <span style="font-size: 10px">نمایش دانش آموزان فعال</span>
              <switch-button
                activeLabel="فعال"
                deactiveLabel="غیرفعال"
                :val="activeStudents" />
            </div>
            <div class="b fRow jStart aCenter"
              @click="handleGetStudent"
              style="margin-right: 8px">
              <i class="material-icons-round">search</i>
              <label>جستجو</label>
            </div>
            <div class="b fRow jStart aCenter active"
              v-if="false"
              @click="getDeactiveStudents" style="width: 140px">
              <i class="material-icons-round">assignment</i>
              <label>تفاهم‌نامه غیرفعال</label>
            </div>
            <div class="b fRow jStart aCenter active"
              @click="handleGetStudent" style="width: 140px">
              <i class="material-icons-round">repeat</i>
              <label>بارگیری دوباره</label>
            </div>
          </div>
          <div class="studentsRows fCol jStart aStart fullWidth" v-if="loaded">
            <student-row
              v-for="(item, index) in studentsList"
              v-bind:key="index"
              @refresh="getStudents"
              @edit="goEdit($event)"
              :idx="index"
              :data="item"/>
          </div>
          <div class="fCol jCenter aCenter fullWidth"
            v-if="loading || noContent">
            <p-bar
              :loading="loading"
              :notYet="notYet"
              :noContent="noContent"
              :notFound="notFound"
              :error="error" />
          </div>
          <div class="fRow jStart aCenter fullWidth" v-if="loaded">
            <pagination :active='activePage' :psize='pageSize'
              @resetPageSize="resetPageSize($event)"
              :pages='howManyPages' @goToPage="GoToPages($event)" />
          </div>
        </div>
        <!-- صفحه اضافه کردن مشاور -->
        <div class="uploadersHolder fRow jBetween aCenter wrap fullWidth"
          v-if='isConvention'>
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>برای ثبت مشاور جدید فرم زیر را پر کنید.</h3>
            <div class="ruleBox fCol jStart aStart w50">
              <h4>پر کردن تمامی موارد الزامی می‌باشد</h4>
            </div>
          </div>
          <div class="fRow jBetween aStart fulWidth assignmentForm">
            <!-- فرم مشاور -->
            <div class="w40 fRow jBetween aCenter wrap">
              <div class="fullWidth fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: adNameErr}">account_circle</i>
                  نام - {{conventionName.length}}/24</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="نام"
                    type="text" v-model="conventionName">
                </div>
              </div>
              <div class="fullWidth fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: adFamilyErr}">account_circle</i>
                  نام خانوادگی - {{conventionFamily.length}}/24</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="نام خانوادگی"
                    type="text" v-model="conventionFamily">
                </div>
              </div>
              <div class="fullWidth fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: adPhoneErr}">call</i>
                  شماره تماس - {{conventionPhone.length}}/11</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="شماره تماس"
                    type="number" v-model="conventionPhone">
                </div>
              </div>
              <div class="fullWidth fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: fieldErr}">category</i>
                  انتخاب دسترسی</span>
                  <cool-select
                    class="fullWidth"
                    @select="selected($event, 'access')"
                    v-model="access"
                    disable-search
                    :items="accesses"
                    :item-value="accesses.id"
                    :item-text="accesses.title">
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: accesses }">
                      <div style="display: flex; align-items: center;">
                        <div>
                          {{ accesses.title }}
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text access) -->
                    <template slot="selection" slot-scope="{ item: accesses }">
                      <div>
                        {{ accesses.title }}
                      </div>
                    </template>
                  </cool-select>
              </div>
              <div class="fullWidth fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: fieldErr}">category</i>
                  انتخاب نوع مشاور</span>
                  <cool-select
                    class="fullWidth"
                    @select="selected($event, 'consultantType')"
                    v-model="consultantType"
                    disable-search
                    :items="consultantTypes"
                    :item-value="consultantTypes.id"
                    :item-text="consultantTypes.title">
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: consultantTypes }">
                      <div style="display: flex; align-items: center;">
                        <div>
                          {{ consultantTypes.title }}
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text access) -->
                    <template slot="selection" slot-scope="{ item: consultantTypes }">
                      <div>
                        {{ consultantTypes.title }}
                      </div>
                    </template>
                  </cool-select>
              </div>
              <div class="fRow jStart aCenter fullWidth">
                <div class="b fRow jStart aCenter big"
                  @click="newConventions"
                  v-if="!moshaverEditMode"
                  v-bind:class="{active: isConventionReady}">
                  <i class="material-icons-round">done_all</i>
                  <label>ثبت مشاور جدید</label>
                </div>
                <div class="b fRow jStart aCenter big"
                  @click="editMoshaver"
                  v-if="moshaverEditMode"
                  v-bind:class="{active: isConventionReady}">
                  <i class="material-icons-round">save</i>
                  <label>ثبت تغییرات مشاور</label>
                </div>
                <div class="b fRow jStart aCenter mini" @click="clearConsultantForm">
                  <i class="material-icons-round">delete</i>
                  <label>پاک کردن فرم</label>
                </div>
              </div>
            </div>
            <!-- لیست مشاور ها -->
            <div class="w60 fRow jBetween aCenter wrap assignments">
              <div class="fRow jStart aCenter heads">
                <i class="material-icons-round">account_circle</i>
                لیست مشاورها
              </div>
              <div class="fCol jCenter aCenter fullWidth"
                v-if="loading || noContent">
                <p-bar
                  :loading="loading"
                  :notYet="notYet"
                  :noContent="noContent"
                  :notFound="notFound"
                  :error="error" />
              </div>
              <ul class="fullWidth fCol jStart aCenter"
                v-if="!loading && !noContent">
                <div class="fullWidth fCol jStart aStart inputHolder" style="padding: 8px">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round">search</i>
                    جستجوی نام مشاور</span>
                  <div class="fRow jStart aCenter fullWidth inputWraper">
                    <input class="transition-fast" placeholder="نام مشاور را وارد کنید"
                      type="text" v-model="moshaversSearch">
                  </div>
                </div>
                <div class="fullWidth fRow jBetween aCenter" style="padding: 0 8px 8px 8px">
                  <radio
                    v-for="(item, index) in moshaversFilters" v-bind:key="index"
                    :simple="true"
                    :data="item"
                    class="w33"
                    :selected="item.id === moshaversFilter"
                    @click.native="moshaversFilter = item.id" />
                </div>
                <li class="fRow jStart aCenter"
                  v-for="(item, index) in filteredMoshavers"
                  v-bind:key="index">
                  <moshaver-item
                    :data="item"
                    :indexs="index"
                    @edit="goEditMoshaver($event)"
                    @refresh="getConventions"/>
                </li>
              </ul>
              <div class="fullWidth fCol jCenter aCenter noMoshavers"
                v-if="filteredMoshavers.length === 0 && loaded">
                <i class="material-icons-round b">info</i>
                مشاوری برای نمایش وجود ندارد
                <div class="b fRow jStart aCenter mini"
                  @click="resetMoshaverFilters">
                  <i class="material-icons-round">sync</i>
                  <label>ریست کردن فیلتر</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
      </card>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
    <modal v-if="modalShow">
      <card w="580px">
        <label class="question">با ترک این صفحه آپلودها متوقف می‌شوند.
          آیا مایل به ترک این صفحه هستید؟</label>
        <div class="fullWidth wrap aStart jStart fRow btnRow">
          <btn label="نمایش لیست ویدئوها" btnWidth='236px' bc='#ff0533'
          icon="delete_sweep" @click.native="showListAnyWay"/>
          <keep-alive>
            <btn fabBtn='true' label="بازگشت" btnWidth='auto'
              @click.native="closeModal" bc='#aaaaaa' icon="close"/>
          </keep-alive>
        </div>
      </card>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import Card from '@/components/Card.vue';
import Btn from '@/components/Btn.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import Toast from '@/components/Toast.vue';
import ticks from '@/mixins/ticks';
import Modal from '@/components/Modal.vue';
import { CoolSelect } from 'vue-cool-select';
import moment from 'moment-jalaali';
import Pagination from '@/components/Pagination.vue';
import pBar from '@/components/pBar.vue';
import MoshaverItem from '@/components/ConventionItem.vue';
import StudentRow from '@/components/StudentRow.vue';
import SwitchButton from '@/components/SwitchButton.vue';
import PayItem from '@/components/accounting/PayItem.vue';
import Radio from '@/components/Radio.vue';
import 'vue-cool-select/dist/themes/material-design-dark.scss';
import '@/assets/new.scss';

export default {
  mixins: [errorHandler, makeToast, ticks],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      isAssignment: false,
      isStudents: true,
      isConvention: false,
      isExamList: false,
      isBank: true,
      startDate: '',
      startDateShow: '',
      stErr: true,
      endDate: '',
      endDateShow: '',
      etErr: true,
      startPayDate: '',
      startPayDateShow: '',
      stpErr: true,
      payMethods: [
        {
          id: 1,
          title: 'پرداخت نقدی',
        },
        {
          id: 2,
          title: 'پرداخت کارت به کارت',
        },
        {
          id: 3,
          title: 'پرداخت چکی',
        },
        {
          id: 4,
          title: 'پرداخت نشده',
        },
      ],
      payMethod: '',
      payMethodErr: true,
      notPayed: false,
      payDate: '',
      payDateShow: '',
      payDateErr: true,
      payAmount: '',
      payAmountErr: true,
      payDesc: '',
      payDescErr: true,
      payTypes: [
        {
          id: 2,
          title: 'پرداخت اقساطی',
        },
        {
          id: 1,
          title: 'پرداخت نقدی',
        },
      ],
      payType: {
        id: 0,
      },
      payTypeErr: true,
      questionBank: [
        {
          id: 0,
          title: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ؟',
          img: '',
          level: 'easy',
        },
        {
          id: 1,
          title: 'کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد؟',
          img: 'https://api.rimik.ir/photo/4bb8eb17-2413-4497-9093-44f1ca691b79.jpg',
          level: 'hard',
        },
        {
          id: 2,
          title: 'کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد ؟',
          img: '',
          level: 'hard',
        },
        {
          id: 3,
          title: 'تمام و دشواری موجود در ارائه؟',
          img: '',
          level: 'normal',
        },
        {
          id: 4,
          title: 'شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی؟',
          img: '',
          level: 'hard',
        },
        {
          id: 5,
          title: 'جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد؟',
          img: '',
          level: 'easy',
        },
      ],
      // simple example of items
      fields: [
        {
          id: -1,
          title: 'صبر کنید...',
        },
      ],
      field: '',
      fieldErr: true,
      grades: [
        {
          id: -1,
          title: 'ابتدا رشته را انتخاب کنید',
        },
      ],
      grade: '',
      gradeErr: true,
      plans: [
        {
          id: 0,
          title: 'ابتدا رشته را انتخاب کنید',
        },
      ],
      plan: '',
      planErr: true,
      conventions: [
        {
          id: 0,
          title: 'لیست مشاور از وب سرویس',
        },
      ],
      convention: '',
      conventionErr: true,
      // there will be a selected item
      fieldSelected: '',
      // other
      modalShow: false,
      name: '',
      nameErr: true,
      lastName: '',
      lastNameErr: true,
      // parents ↓
      father: '',
      fatherErr: true,
      fatherJob: '',
      fatherJobErr: true,
      fatherEdu: '',
      fatherEduErr: true,
      fatherPhone: '',
      fatherPhoneErr: true,
      mother: '',
      motherErr: true,
      motherJob: '',
      motherJobErr: true,
      motherEdu: '',
      motherEduErr: true,
      motherPhone: '',
      motherPhoneErr: true,
      // parents ↑
      assignmentStatus: false,
      melli: '',
      melliErr: true,
      studentPhone: '',
      studentPhoneErr: true,
      // convention form
      conventionName: '',
      adNameErr: true,
      conventionFamily: '',
      adFamilyErr: true,
      conventionPhone: 0,
      adPhoneErr: true,
      conventionsData: [],
      // pagination
      howManyPages: 0,
      pageSize: 10,
      activePage: 1,
      // اطلاعات دانش آموزان
      studentsList: [],
      sSearch: '',
      // moasese
      company: [
      ],
      selectedCompany: -1,
      // convention
      accesses: [
        {
          id: -1,
          title: 'کمی صبر کنید...',
        },
      ],
      access: '',
      accessErr: true,
      consultantTypes: [
        {
          id: 1,
          title: 'مشاور آموزشی',
        },
        {
          id: 2,
          title: 'مشاور جذب',
        },
      ],
      consultantType: '',
      consultantTypeErr: true,
      consultantFilter: 0,
      consultants: [],
      consultantSearch: '',
      selectedConsultants: [],
      selectedConsultantsErr: true,
      selectedItems: [],
      // select lessons for class for students
      classes: [],
      selectedClasses: [],
      selectedClassesErr: true,
      classSearch: '',
      selectedClassItems: [],
      studentSearch: '',
      editMode: false,
      letEditDropDowns: false,
      editData: {},
      activeStudents: true,
      payItemArray: [1],
      completedPayItems: [],
      // data baraye moshavers
      moshaversSearch: '',
      moshaversFilter: 0,
      moshaversFilters: [
        {
          id: 0,
          title: 'نمایش همه',
          desc: '',
        },
        {
          id: 2,
          title: 'مشاور جذب',
          desc: '',
        },
        {
          id: 1,
          title: 'مشاور آموزشی',
          desc: '',
        },
      ],
      studentsSort: 0,
      studentsSorts: [
        {
          id: 0,
          title: 'آپشن یک',
          desc: '',
        },
        {
          id: 1,
          title: 'آپشن دو',
          desc: '',
        },
        {
          id: 2,
          title: 'آپشن سه',
          desc: '',
        },
      ],
      moshaverEditMode: false,
      moshaverEditData: {},
      amount: '',
      amountErr: true,
      qestAmount: '',
      qestAmountErr: true,
      // export assignments filter
      exportFiltersArray: [
        {
          id: 0,
          title: 'مشخصات والدین',
          desc: '',
        },
        {
          id: 1,
          title: 'اطلاعات تحصیلی',
          desc: '',
        },
        {
          id: 2,
          title: 'مشاورها',
          desc: '',
        },
        {
          id: 3,
          title: 'دوره‌ها / کلاس‌ها',
          desc: '',
        },
        {
          id: 4,
          title: 'مالی',
          desc: '',
        },
      ],
      exportFilters: [],
    };
  },
  methods: {
    selectExportFilter(id) {
      const index = this.exportFilters.indexOf(id);
      if (index === -1) {
        this.exportFilters.push(id);
      } else {
        this.exportFilters.splice(index, 1);
      }
    },
    addNewPayItem() {
      this.payItemArray.push(1);
    },
    itemChanged(e) {
      // اگر این آیتم
      const a = this.isItemInArray(e.index);
      if (a !== -1) {
        this.completedPayItems.splice(a, 1);
      }
    },
    getResult(e) {
      if (e !== false) {
        const a = this.isItemInArray(e.index);
        if (a === -1) {
          this.completedPayItems.push(e);
        } else {
          this.completedPayItems[a] = e;
        }
      }
    },
    deleteFromArray(e) {
      const a = this.isItemInArray(e);
      if (a !== -1) {
        this.completedPayItems.splice(a, 1);
      }
    },
    isItemInArray(index) {
      let a = -1;
      for (let i = 0; i < this.completedPayItems.length; i += 1) {
        if (this.completedPayItems[i].index === index) {
          a = i;
          break;
        }
      }
      return a;
    },
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    backToCourse() {
      this.$store.commit('resetCourseObject');
      this.$router.push('/courses');
    },
    getTeacherPhoto() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Teachers/${this.teacherId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.posts = response.data;
        if (this.posts.isSuccess) {
          // console.log(this.posts);
          this.teacherImg = this.posts.data.user.avatar;
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
    addNewUploader() {
      // alert(event);
      this.isVideoUploading = true;
      this.uploaderCount += 1;
      this.uploaderArray.push(this.uploaderCount.toString());
    },
    closeModal() {
      this.modalShow = false;
    },
    showListAnyWay() {
      this.isVideoUploading = false;
      this.modalShow = false;
      this.toggleSection('list');
    },
    toggleSection(order) {
      this.isAssignment = false;
      this.isConvention = false;
      this.isStudents = false;
      switch (order) {
        case 'form': {
          this.isAssignment = true;
          this.getFields();
          this.getInstitutes();
          this.getConventions();
          break;
        }
        case 'convention': {
          this.editMode = false;
          this.letEditDropDowns = false;
          this.editData = {};
          this.clearStudentForm();
          // 2
          this.isConvention = true;
          this.getConventions();
          this.getAccess();
          break;
        }
        case 'students': {
          this.editMode = false;
          this.letEditDropDowns = false;
          this.editData = {};
          this.clearStudentForm();
          // 2
          this.isStudents = true;
          this.handleGetStudent();
          break;
        }
        default:
          break;
      }
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'field': {
          if (this.field.id !== -1) {
            const a = this.field.id;
            this.plans = [
              {
                id: 1,
                title: 'A+ طرح طلایی',
              },
              {
                id: 2,
                title: 'A طرح طلایی',
              },
              {
                id: 3,
                title: 'B طرح نقره‌ای',
              },
              {
                id: 4,
                title: 'C طرح برنزی',
              },
            ];
            this.getGrades(a);
            this.fieldErr = false;
            this.plan = '';
            this.planErr = true;
          } else {
            this.fieldErr = true;
          }
          break;
        }
        case 'grade': {
          if (this.grade.id !== -1) {
            this.gradeErr = false;
            this.getLessons(this.grade.id);
          } else {
            this.gradeErr = true;
          }
          break;
        }
        case 'plan': {
          if (this.plan.id !== -1) {
            this.planErr = false;
          } else {
            this.planErr = true;
          }
          break;
        }
        case 'payMethod': {
          this.payMethodErr = false;
          if (this.payMethod.id === 4) {
            this.notPayed = true;
            this.payDate = '';
          } else {
            this.notPayed = false;
          }
          break;
        }
        case 'access': {
          if (this.access.id !== -1) {
            this.accessErr = false;
          } else {
            this.accessErr = true;
          }
          break;
        }
        case 'consultantType': {
          if (this.consultantType.id !== -1) {
            this.consultantTypeErr = false;
          } else {
            this.consultantTypeErr = true;
          }
          // console.log(e);
          break;
        }
        default:
          break;
      }
    },
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    GoToPages(event) {
      if (event === 'next') {
        // alert('next');
        this.activePage += 1;
        if (this.activePage > this.howManyPages) {
          this.activePage = 1;
        }
        this.getStudents(this.activePage);
        return;
      }
      if (event === 'prev') {
        this.activePage -= 1;
        if (this.activePage < 1) {
          this.activePage = this.howManyPages;
        }
        this.getStudents(this.activePage);
        return;
      }
      this.getStudents(event);
      this.activePage = event;
    },
    handleGetStudent() {
      if (this.studentSearch !== '') {
        this.searchStudents();
      } else {
        this.searchStudents();
      }
    },
    getStudents(p) {
      this.setMode('loading');
      let tpage = 1;
      if (p !== undefined) {
        tpage = p;
      }
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Students/search/?pageNo=${tpage}&status=${this.activeStudents}&pageSize=${this.pageSize}`;
      if (!this.activeStudents) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Students/search/?pageNo=${tpage}&status=${this.activeStudents}&pageSize=${this.pageSize}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.studentsList = response.data.data.students;
          this.howManyPages = response.data.data.pageCount;
          this.setMode('loaded');
        } else {
          this.makeToast('error', 'خطا در بارگذاری', 3000);
          this.setMode('error', 'خطا در بارگذاری');
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getDeactiveStudents() {
      this.activeStudents = false;
      this.studentSearch = '';
      this.searchStudents();
    },
    searchStudents(p) {
      this.setMode('loading');
      let tpage = 1;
      if (p !== undefined) {
        tpage = p;
      }
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Students/search?pageNo=${tpage}&pageSize=${this.pageSize}&status=${this.activeStudents}&search=${this.arabicToPersian(this.studentSearch)}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.studentsList = response.data.data.students;
          this.howManyPages = response.data.data.pageCount;
          this.setMode('loaded');
        } else {
          this.makeToast('error', 'خطا در بارگذاری', 3000);
          this.setMode('error', 'خطا در بارگذاری');
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getStudentsSearch(p) {
      this.setMode('loading');
      let tpage = 1;
      if (p !== undefined) {
        tpage = p;
      }
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Users/student/search?pageNo=${tpage}&pageSize=${this.pageSize}&search=${this.sSearch}`;
      // const url = 'https://api.rimik.ir/api/v1/Users/studnets?pageNo=1&pageSize=10';
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.studentsList = response.data.data.students;
          this.howManyPages = response.data.data.pageCount;
          this.setMode('loaded');
        } else {
          this.makeToast('error', 'خطا در بارگذاری', 3000);
          this.setMode('error', 'خطا در بارگذاری');
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    resetPageSize(e) {
      this.pageSize = e;
      this.activePage = 1;
      this.getStudents();
    },
    getConventions() {
      this.setMode('loading');
      this.conventions = [{
        title: 'لطفا صبر کنید',
        id: '',
      }];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Consultants`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.conventions = [];
          const arr = response.data.data;
          if (arr.length === 0) {
            this.setMode('noContent');
            // ریست کردن لیست ها
            this.conventions = [{
              title: 'مشاور ثبت نشده',
              id: '',
            }];
          } else {
            for (let i = 0; i < arr.length; i += 1) {
              this.conventions.push({
                id: arr[i].id,
                title: arr[i].fullName,
              });
            }
            this.conventionsData = response.data.data;
            this.consultants = [];
            for (let i = 0; i < this.conventionsData.length; i += 1) {
              const a = {
                id: this.conventionsData[i].id,
                title: this.conventionsData[i].fullName,
                type: this.conventionsData[i].consultantType,
              };
              this.consultants.push(a);
            }
            this.setMode('loaded');
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    newConventions() {
      if (this.isConventionReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Consultants`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            firstName: this.conventionName,
            lastName: this.conventionFamily,
            phoneNumber: `98${this.conventionPhone.slice(1, 11)}`,
            consultantType: this.consultantType.id,
            accessId: this.access.id,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.getConventions();
            this.makeToast('success', 'تفاهم‌نامه جدید با موفقیت ثبت شد', 3000);
            this.clearConsultantForm();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', `${this.errorHandler(error)}`, 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'ابتدا فرم را تکمیل کنید', 3000);
      }
    },
    editMoshaver() {
      if (this.isConventionReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Consultants/${this.moshaverEditData.id}`;
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            firstName: this.conventionName,
            lastName: this.conventionFamily,
            phoneNumber: `98${this.conventionPhone.slice(1, 11)}`,
            consultantType: this.consultantType.id,
            accessId: this.access.id,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.getConventions();
            this.makeToast('success', 'مشاور با موفقیت ویرایش شد', 3000);
            this.clearConsultantForm();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', `${this.errorHandler(error)}`, 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'ابتدا فرم را تکمیل کنید', 3000);
      }
    },
    newStudent() {
      this.setMode('loading');
      const spd = (this.startPayDate === '')
        ? null : this.startPayDate;
      const api = (this.qestAmount === '')
        ? 0 : parseInt(this.qestAmount.replace(/,/g, ''), 10);
      const tp = (this.amount === '')
        ? 0 : parseInt(this.amount.replace(/,/g, ''), 10);
      let finalPaysArray = [];
      if (this.completedPayItems.length > 0) {
        for (let i = 0; i < this.completedPayItems.length; i += 1) {
          finalPaysArray.push(this.completedPayItems[i]);
          if (finalPaysArray[i].checkDate === '') {
            finalPaysArray[i].checkDate = null;
          }
          delete finalPaysArray[i].index;
        }
      } else {
        finalPaysArray = null;
      }
      if (this.isFormReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Students`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            instituteId: this.selectedCompany,
            firstName: this.name,
            lastName: this.lastName,
            nationalCode: this.melli,
            phoneNumber: this.studentPhone.replace('09', '989'),
            fatherName: this.father,
            fatherEducation: this.fatherEdu,
            fatherJob: this.fatherJob,
            fatherMobile: this.fatherPhone.replace('09', '989'),
            motherName: this.mother,
            motherEducation: this.motherEdu,
            motherJob: this.motherJob,
            motherMobile: this.motherPhone.replace('09', '989'),
            fieldId: this.field.id,
            gradeId: this.grade.id,
            planType: this.plan.title,
            startTheContract: this.startDate,
            endTheContract: this.endDate,
            consultantIds: this.selectedConsultants,
            lessonIds: this.selectedClasses.length === 0 ? null : this.selectedClasses,
            payments: finalPaysArray,
            totalPrice: tp,
            amountPerInstallment: api,
            dateOfFirstInstallment: spd,
            status: this.assignmentStatus,
          },
        }).then((response) => {
          this.setMode('loaded');
          if (response.data.isSuccess) {
            this.getConventions();
            this.makeToast('success', 'تفاهم‌نامه‌ی جدید با موفقیت ثبت شد', 3000);
            this.clearStudentForm();
            this.initDefaultForBashirPoor();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.setMode('loaded');
          this.makeToast('error', error.response.data, 3000);
        }).catch(() => {
          this.setMode('loaded');
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.setMode('loaded');
        this.makeToast('error', 'ابتدا فرم را تکمیل کنید', 3000);
      }
    },
    editStudent() {
      if (this.isEditFormReady) {
        const spd = (this.startPayDate === '' || !this.assignmentStatus)
          ? null : this.startPayDate;
        const api = (this.qestAmount === '' || !this.assignmentStatus)
          ? 0 : parseInt(this.qestAmount.replace(/,/g, ''), 10);
        const tp = (this.amount === '' || !this.assignmentStatus)
          ? 0 : parseInt(this.amount.replace(/,/g, ''), 10);
        const reqUrl = `${this.baseURL}/api/v${this.V}/Students/${this.editData.studentId}`;
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            instituteId: this.selectedCompany,
            firstName: this.name,
            lastName: this.lastName,
            nationalCode: this.melli,
            phoneNumber: this.studentPhone.replace('09', '989'),
            fatherName: this.father,
            fatherEducation: this.fatherEdu,
            fatherJob: this.fatherJob,
            fatherMobile: this.fatherPhone.replace('09', '989'),
            motherName: this.mother,
            motherEducation: this.motherEdu,
            motherJob: this.motherJob,
            motherMobile: this.motherPhone.replace('09', '989'),
            fieldId: this.letEditDropDowns ? this.field.id : this.editData.field.id,
            gradeId: this.letEditDropDowns ? this.grade.id : this.editData.grade.id,
            planType: this.letEditDropDowns ? this.plan.title : this.editData.planType,
            startTheContract: this.startDate,
            endTheContract: this.endDate,
            consultantIds: this.selectedConsultants,
            lessonIds: this.selectedClasses.length === 0 ? null : this.selectedClasses,
            totalPrice: tp,
            amountPerInstallment: api,
            dateOfFirstInstallment: spd,
            status: this.assignmentStatus,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.getConventions();
            this.makeToast('success', 'تفاهم‌نامه‌ی جدید با موفقیت ثبت شد', 3000);
            this.clearStudentForm();
            this.toggleSection('students');
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', `${this.errorHandler(error)}. درستی شماره را بررسی نمایید`, 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'ابتدا فرم را تکمیل کنید', 3000);
      }
    },
    clearStudentForm() {
      this.selectedCompany = -1;
      this.name = '';
      this.lastName = '';
      this.melli = '';
      this.studentPhone = '';
      this.father = '';
      this.fatherJob = '';
      this.fatherEdu = '';
      this.fatherPhone = '';
      this.mother = '';
      this.motherJob = '';
      this.motherEdu = '';
      this.motherPhone = '';
      this.startDate = '';
      this.endDate = '';
      this.selectedClasses = [];
      this.selectedConsultants = [];
      this.plan = '';
      this.field = '';
      this.grade = '';
      this.planErr = true;
      this.fieldErr = true;
      this.gradeErr = true;
      this.editData = {};
      this.editMode = false;
      this.payItemArray = [];
      this.payItemArray = [1];
      this.assignmentStatus = false;
      this.payType = {};
      this.amount = '';
      this.qestAmount = '';
      this.startPayDate = '';
      this.studentSearch = '';
    },
    clearConsultantForm() {
      this.moshaverEditMode = false;
      this.moshaverEditData = {};
      this.conventionName = '';
      this.conventionFamily = '';
      this.conventionPhone = '';
      this.consultantType = '';
      this.access = '';
    },
    getInstitutes() {
      this.company = [];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Institutes`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          const r = response.data.data;
          if (r.length === 0) {
            this.makeToast('error', 'هیچ مؤسسه‌ای ثبت نشده', 3000);
          } else {
            this.company = [];
            for (let i = 0; i < r.length; i += 1) {
              if (r[i].status) {
                this.company.push({
                  id: r[i].id,
                  title: r[i].title,
                });
              }
            }
            this.responseEmpty = false;
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    // dynamic fields
    getFields() {
      this.fields = [
        {
          id: -1,
          title: 'کمی صبر کنید',
        },
      ];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Fields`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          if (response.data.data.length === 0) {
            this.fields = [
              {
                id: -1,
                title: 'هیچ رشته‌ای ثبت نشده',
              },
            ];
          } else {
            const arr = response.data.data;
            this.fields = [];
            for (let i = 0; i < arr.length; i += 1) {
              const item = {
                id: arr[i].id,
                title: arr[i].title,
              };
              this.fields.push(item);
            }
            // خالی نیست
          }
        } else {
          this.makeToast('error', 'خطا در دریافت رشته‌ها', 3000);
          this.fields = [
            {
              id: -1,
              title: 'خطا در دریافت رشته‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.fields = [
          {
            id: -1,
            title: this.errorHandler(error),
          },
        ];
      });
    },
    // get grades
    getGrades(f) {
      this.grades = [
        {
          id: -1,
          title: 'کمی صبر کنید',
        },
      ];
      let reqUrl = `${this.baseURL}/api/v${this.V}/Grades`;
      if (f !== -1) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Grades?fieldId=${f}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          // اگه لیست خالی بود
          if (response.data.data.length === 0) {
            this.grades = [
              {
                id: -1,
                title: 'هیچ پایه‌ای ثبت نشده',
              },
            ];
          } else {
            const r = response.data.data;
            // console.log(r);
            this.grades = [];
            for (let i = 0; i < r.length; i += 1) {
              const a = {
                id: r[i].id,
                title: r[i].title,
              };
              this.grades.push(a);
            }
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    // get lesson
    getLessons(f) {
      let reqUrl = `${this.baseURL}/api/v${this.V}/Lessons`;
      if (f !== 0) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Lessons?gradeId=${f}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        const res = response.data.data;
        if (response.data.isSuccess) {
          if (res.length === 0) {
            this.responseEmpty = true;
          } else {
            this.classes = [];
            for (let i = 0; i < res.length; i += 1) {
              const a = {
                id: res[i].id,
                title: res[i].title,
              };
              this.classes.push(a);
            }
          }
        } else {
          this.makeToast('error', 'خطایی رخ داده', 3000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    // get access
    getAccess() {
      this.accesses = [
        {
          id: -1,
          title: 'کمی صبر کنید',
        },
      ];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Accesses`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          if (response.data.data.length === 0) {
            this.accesses = [
              {
                id: -1,
                title: 'هیچ دسترسی‌ای ثبت نشده',
              },
            ];
          } else {
            const arr = response.data.data;
            // console.log(arr);
            this.accesses = [];
            for (let i = 0; i < arr.length; i += 1) {
              const item = {
                id: arr[i].id,
                title: arr[i].title,
              };
              this.accesses.push(item);
            }
            // خالی نیست
          }
        } else {
          this.makeToast('error', 'خطا در دریافت دسترسی‌ها', 3000);
          this.accesses = [
            {
              id: -1,
              title: 'خطا در دریافت دسترسی‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.accesses = [
          {
            id: -1,
            title: this.errorHandler(error),
          },
        ];
      });
    },
    selectConsultant(id) {
      const isThere = this.selectedConsultants.indexOf(id);
      if (isThere === -1) {
        this.selectedConsultants.push(id);
      } else {
        this.selectedConsultants.splice(isThere, 1);
      }
      // console.log(this.selectedConsultants);
    },
    deleteConsultant(i) {
      // console.log(i);
      const index = this.selectedConsultants.indexOf(i);
      this.selectedConsultants.splice(index, 1);
    },
    selectClass(id) {
      const isThere = this.selectedClasses.indexOf(id);
      if (isThere === -1) {
        this.selectedClasses.push(id);
      } else {
        this.selectedClasses.splice(isThere, 1);
      }
      // console.log(this.selectedClasses);
    },
    deleteClass(i) {
      // console.log(i);
      const index = this.selectedClasses.indexOf(i);
      this.selectedClasses.splice(index, 1);
    },
    goEdit(e) {
      // console.warn('from assignment', e);
      this.editMode = true;
      this.toggleSection('form');
      this.editData = e;
      this.payType = {};
      // init input by data
      this.selectedCompany = e.institute.id;
      this.name = e.firstName;
      this.lastName = e.lastName;
      this.melli = e.nationalCode;
      this.studentPhone = e.mobile.replace('98', '0');
      this.father = e.fatherFullName;
      this.fatherJob = e.fatherJob;
      this.fatherEdu = e.fatherEducation;
      this.fatherPhone = e.fatherMobile.replace('98', '0');
      this.mother = e.motherFullName;
      this.motherJob = e.motherJob;
      this.motherEdu = e.motherEducation;
      this.motherPhone = e.motherMobile.replace('98', '0');
      this.startDate = e.startTheContract;
      this.endDate = e.endTheContract;
      // create consultants array
      this.selectedConsultants = [];
      for (let i = 0; i < e.consultants.length; i += 1) {
        this.selectedConsultants.push(e.consultants[i].id);
      }
      this.getLessons(e.grade.id);
      this.selectedClasses = [];
      for (let j = 0; j < e.lessons.length; j += 1) {
        this.selectedClasses.push(e.lessons[j].id);
      }
      // console.warn(this.selectedClasses);
      this.field = {
        id: e.field.id,
        title: e.field.title,
      };
      // console.warn(this.field);
      this.assignmentStatus = e.status;
      this.amount = `${e.totalPrice}`;
      this.qestAmount = `${e.amountPerInstallment}`;
      setTimeout(() => {
        if (!this.assignmentStatus) {
          this.payType = {
            id: 0,
          };
        } else {
          const isQest = e.totalPrice > 0
            && e.amountPerInstallment > 0;
          const isCash = e.totalPrice > 0
            && e.amountPerInstallment < 1;
          if (isCash) {
            this.payType = {
              id: 1,
              title: 'پرداخت نقدی',
            };
          }
          if (isQest) {
            this.payType = {
              id: 2,
              title: 'پرداخت اقساطی',
            };
          }
        }
        setTimeout(() => {
          this.startPayDate = e.dateOfFirstInstallment;
        }, 100);
      }, 200);
    },
    arabicToPersian() {
      let a = this.studentSearch.replace(/ك/g, 'ک');
      a = this.studentSearch.replace(/ي/g, 'ی');
      return a;
    },
    resetMoshaverFilters() {
      this.moshaversSearch = '';
      this.moshaversFilter = 0;
    },
    goEditMoshaver(e) {
      this.moshaverEditMode = true;
      this.moshaverEditData = e;
      this.conventionName = e.firstName;
      this.conventionFamily = e.lastName;
      this.conventionPhone = e.mobile.replace('989', '09');
      this.consultantType = {
        id: e.consultantType,
        title: e.consultantType === 1 ? 'مشاور آموزشی' : 'مشاور جذب',
      };
    },
    getRandomInt(mn, mx) {
      const min = Math.ceil(mn);
      const max = Math.floor(mx);
      return Math.floor(Math.random() * (max - min) + min);
      //  The maximum is exclusive and the minimum is inclusive
    },
    initDefaultForBashirPoor() {
      setTimeout(() => {
        this.father = '{نام پدر}';
        this.fatherJob = '{شغل پدر}';
        this.fatherEdu = '{تحصیلات پدر}';
        this.fatherPhone = '09123456987';
        this.mother = '{نام مادر}';
        this.motherJob = '{شغل مادر}';
        this.motherEdu = '{تحصیلات مادر}';
        this.motherPhone = '09132456789';
        this.melli = `${this.getRandomInt(1000000000, 9999999999)}`;
        this.startDate = '2022-05-22T00:00';
        this.endDate = '2023-08-23T00:00';
      }, 1000);
    },
  },
  components: {
    RightMenu,
    ToolBar,
    DashboardPage,
    Card,
    Btn,
    Toast,
    Modal,
    CoolSelect,
    Pagination,
    pBar,
    MoshaverItem,
    SwitchButton,
    PayItem,
    Radio,
    StudentRow,
  },
  watch: {
    fieldSelected() {
    },
    name() {
      if (this.name.length === 0) {
        this.nameErr = true;
      } else if (this.name.length > 24) {
        this.name = this.name.substr(0, 24);
        this.nameErr = false;
      } else {
        this.nameErr = false;
      }
    },
    lastName() {
      if (this.lastName.length === 0) {
        this.lastNameErr = true;
      } else if (this.lastName.length > 24) {
        this.lastName = this.lastName.substr(0, 24);
        this.lastNameErr = false;
      } else {
        this.lastNameErr = false;
      }
    },
    father() {
      if (this.father.length === 0) {
        this.fatherErr = true;
      } else if (this.father.length > 40) {
        this.father = this.father.substr(0, 40);
        this.fatherErr = false;
      } else {
        this.fatherErr = false;
      }
    },
    fatherJob() {
      if (this.fatherJob.length === 0) {
        this.fatherJobErr = true;
      } else if (this.fatherJob.length > 40) {
        this.fatherJob = this.fatherJob.substr(0, 40);
        this.fatherJobErr = false;
      } else {
        this.fatherJobErr = false;
      }
    },
    fatherEdu() {
      if (this.fatherEdu.length === 0) {
        this.fatherEduErr = true;
      } else if (this.fatherEdu.length > 40) {
        this.fatherEdu = this.fatherEdu.substr(0, 40);
        this.fatherEduErr = false;
      } else {
        this.fatherEduErr = false;
      }
    },
    fatherPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.fatherPhone.length > 11) {
        this.fatherPhone = this.fatherPhone.substr(0, 11);
        // console.log(this.message);
        this.fatherPhoneErr = false;
      }
      if (this.fatherPhone.match(phonePattern)
        && this.fatherPhone.charAt(0) === '0'
        && this.fatherPhone.charAt(1) === '9') {
        this.fatherPhoneErr = false;
      } else {
        this.fatherPhoneErr = true;
      }
    },
    mother() {
      if (this.mother.length === 0) {
        this.motherErr = true;
      } else if (this.mother.length > 40) {
        this.mother = this.mother.substr(0, 40);
        this.motherErr = false;
      } else {
        this.motherErr = false;
      }
    },
    motherJob() {
      if (this.motherJob.length === 0) {
        this.motherJobErr = true;
      } else if (this.motherJob.length > 40) {
        this.motherJob = this.motherJob.substr(0, 40);
        this.motherJobErr = false;
      } else {
        this.motherJobErr = false;
      }
    },
    motherEdu() {
      if (this.motherEdu.length === 0) {
        this.motherEduErr = true;
      } else if (this.motherEdu.length > 40) {
        this.motherEdu = this.motherEdu.substr(0, 40);
        this.motherEduErr = false;
      } else {
        this.motherEduErr = false;
      }
    },
    motherPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.motherPhone.length > 11) {
        this.motherPhone = this.motherPhone.substr(0, 11);
        // console.log(this.message);
        this.motherPhoneErr = false;
      }
      if (this.motherPhone.match(phonePattern)
        && this.motherPhone.charAt(0) === '0'
        && this.motherPhone.charAt(1) === '9') {
        this.motherPhoneErr = false;
      } else {
        this.motherPhoneErr = true;
      }
    },
    melli() {
      if (this.melli.length === 10) {
        this.melliErr = false;
      } else if (this.melli.length > 10) {
        this.melli = this.melli.substr(0, 10);
        this.melliErr = false;
      } else {
        this.melliErr = true;
      }
    },
    startDate() {
      if (this.startDate !== '') {
        console.log('date', this.startDate);
        this.startDateShow = moment(this.startDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.stErr = false;
      } else {
        this.startDateShow = '';
        this.stErr = true;
      }
    },
    endDate() {
      if (this.endDate !== '') {
        // console.log('date', this.endDate);
        this.endDateShow = moment(this.endDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.etErr = false;
      } else {
        this.endDateShow = '';
        this.etErr = true;
      }
    },
    payDate() {
      if (this.payDate !== '') {
        // console.log('date', this.payDate);
        this.payDateShow = moment(this.payDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.payDateErr = false;
      } else {
        this.payDateErr = true;
        this.payDateShow = '';
      }
    },
    payAmount() {
      let p = this.payAmount;
      p = p.replace(/,/g, '');
      if (!/^\d+$/.test(p) || (p.charAt(0) === '0' || p.charAt(0) === 0)) {
        p = p.substr(0, p.length - 1);
      }
      if (p.length > 12) {
        this.payAmount = this.payAmount.substr(0, 12);
      }
      p = this.commaSep(p);
      this.payAmount = p;
      if (this.payAmount.length > 3) {
        this.payAmountErr = false;
      } else {
        this.payAmountErr = true;
      }
    },
    payDesc() {
      if (this.payDesc.length === 0) {
        this.payDescErr = true;
      } else if (this.payDesc.length > 128) {
        this.payDesc = this.payDesc.substr(0, 128);
        this.payDescErr = false;
      } else {
        this.payDescErr = false;
      }
    },
    conventionName() {
      if (this.conventionName.length === 0) {
        this.adNameErr = true;
      } else if (this.conventionName.length > 24) {
        this.conventionName = this.conventionName.substr(0, 24);
        this.adNameErr = false;
      } else {
        this.adNameErr = false;
      }
    },
    conventionFamily() {
      if (this.conventionFamily.length === 0) {
        this.adFamilyErr = true;
      } else if (this.conventionFamily.length > 24) {
        this.conventionFamily = this.conventionFamily.substr(0, 24);
        this.adFamilyErr = false;
      } else {
        this.adFamilyErr = false;
      }
    },
    conventionPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.conventionPhone.length > 11) {
        this.conventionPhone = this.conventionPhone.substr(0, 11);
        // console.log(this.message);
        this.adPhoneErr = false;
      }
      if (this.conventionPhone.match(phonePattern)
        && this.conventionPhone.charAt(0) === '0'
        && this.conventionPhone.charAt(1) === '9') {
        this.adPhoneErr = false;
      } else {
        this.adPhoneErr = true;
      }
    },
    studentPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.studentPhone.length > 11) {
        this.studentPhone = this.studentPhone.substr(0, 11);
        // console.log(this.message);
        this.studentPhoneErr = false;
      }
      if (this.studentPhone.match(phonePattern)
        && this.studentPhone.charAt(0) === '0'
        && this.studentPhone.charAt(1) === '9') {
        this.studentPhoneErr = false;
      } else {
        this.studentPhoneErr = true;
      }
    },
    isStudents() {
      if (this.isStudents) {
        this.handleGetStudent();
      }
    },
    selectedConsultants() {
      this.selectedItems = [];
      for (let i = 0; i < this.consultants.length; i += 1) {
        if (this.selectedConsultants.includes(this.consultants[i].id)) {
          this.selectedItems.push(this.consultants[i]);
        }
      }
      if (this.selectedConsultants.length === 0) {
        this.selectedConsultantsErr = true;
      } else {
        this.selectedConsultantsErr = false;
      }
    },
    selectedClasses() {
      this.selectedClassItems = [];
      for (let i = 0; i < this.classes.length; i += 1) {
        if (this.selectedClasses.includes(this.classes[i].id)) {
          this.selectedClassItems.push(this.classes[i]);
        }
      }
      if (this.selectedClasses.length === 0) {
        this.selectedClassesErr = true;
      } else {
        this.selectedClassesErr = false;
      }
    },
    activeStudents() {
      this.activePage = 1;
      this.searchStudents();
    },
    payType() {
      this.payTypeErr = this.payType.id === 0;
      this.startPayDate = '';
    },
    startPayDate() {
      if (this.startPayDate !== '') {
        this.startPayDateShow = moment(this.startPayDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.stpErr = false;
      } else {
        this.startPayDateShow = '';
        this.stpErr = true;
      }
    },
    amount() {
      let p = this.amount;
      p = p.replace(/,/g, '');
      if (!/^\d+$/.test(p) || (p.charAt(0) === '0' || p.charAt(0) === 0)) {
        p = p.substr(0, p.length - 1);
      }
      if (p.length > 12) {
        this.amount = this.amount.substr(0, 12);
      }
      p = this.commaSep(p);
      this.amount = p;
      if (this.amount.length > 3) {
        this.amountErr = false;
      } else {
        this.amountErr = true;
      }
    },
    qestAmount() {
      let p = this.qestAmount;
      p = p.replace(/,/g, '');
      if (!/^\d+$/.test(p) || (p.charAt(0) === '0' || p.charAt(0) === 0)) {
        p = p.substr(0, p.length - 1);
      }
      if (p.length > 12) {
        this.qestAmount = this.qestAmount.substr(0, 12);
      }
      p = this.commaSep(p);
      this.qestAmount = p;
      if (this.qestAmount.length > 3) {
        this.qestAmountErr = false;
      } else {
        this.qestAmountErr = true;
      }
    },
  },
  computed: {
    isPayReady() {
      let a = false;
      if (this.notPayed) {
        // a = !this.payAmountErr
        //   && !this.payMethodErr
        //   && !this.payDescErr;
        a = true;
      } else {
        a = !this.payDateErr
          && !this.payAmountErr
          && !this.payMethodErr
          && !this.payDescErr;
      }
      return a;
    },
    isStudentPayDataReady() {
      let a = false;
      if (this.assignmentStatus) {
        if (!this.payTypeErr) {
          switch (this.payType.id) {
            case 1: {
              a = !this.amountErr;
              break;
            }
            case 2: {
              a = !this.amountErr && !this.qestAmountErr && !this.stpErr;
              break;
            }
            default:
              break;
          }
        }
      } else {
        a = true;
      }
      return a;
    },
    isFormReady() {
      const a = this.selectedCompany !== -1
        && !this.nameErr
        && !this.lastNameErr
        && !this.melliErr
        && !this.fatherErr
        && !this.fatherJobErr
        && !this.fatherEduErr
        && !this.fatherPhoneErr
        && !this.motherErr
        && !this.motherJobErr
        && !this.motherEduErr
        && !this.motherPhoneErr
        && !this.fieldErr
        && !this.gradeErr
        && !this.planErr
        && !this.stErr
        && !this.etErr
        && this.isStudentPayDataReady;
      return a;
    },
    isEditFormReady() {
      const a = this.selectedCompany !== -1
        && !this.nameErr
        && !this.lastNameErr
        && !this.melliErr
        && !this.fatherErr
        && !this.fatherJobErr
        && !this.fatherEduErr
        && !this.fatherPhoneErr
        && !this.motherErr
        && !this.motherJobErr
        && !this.motherEduErr
        && !this.motherPhoneErr
        && (!this.letEditDropDowns || (this.letEditDropDowns && !this.fieldErr))
        && (!this.letEditDropDowns || (this.letEditDropDowns && !this.gradeErr))
        && (!this.letEditDropDowns || (this.letEditDropDowns && !this.planErr))
        && !this.stErr
        && !this.etErr
        && !this.selectedConsultantsErr
        && this.isStudentPayDataReady;
      // console.clear();
      // console.log(a);
      return a;
    },
    isConventionReady() {
      const a = !this.adNameErr
        && !this.adFamilyErr
        && !this.adPhoneErr
        && !this.accessErr
        && !this.consultantTypeErr;
      return a;
    },
    filteredConsultants() {
      // eslint-disable-next-line
      return this.consultants.filter((item) => item.title.toLowerCase().includes(this.consultantSearch.toLowerCase()));
    },
    filteredClasses() {
      // eslint-disable-next-line
      return this.classes.filter((item) => item.title.toLowerCase().includes(this.classSearch.toLowerCase()));
    },
    filteredStudentsList() {
      // eslint-disable-next-line
      return this.studentsList.filter((item) => item.fullName.toLowerCase().includes(this.studentSearch.toLowerCase()));
    },
    // filtereds
    filteredMoshavers() {
      // eslint-disable-next-line
      return this.conventionsData.filter((item) => item.fullName.toLowerCase().includes(this.moshaversSearch.toLowerCase())
        && (this.moshaversFilter === 0 ? true : item.consultantType === this.moshaversFilter));
    },
  },
  mounted() {
    this.$nextTick(() => {
      // this.initDefaultForBashirPoor();
      this.$store.commit('setLoadingOff');
      this.toggleSection('form');
    });
  },
};
</script>

<style lang="scss" scoped>
$azadSecondary: #8e9bd6;
$azadPrimary: #2156ae;
$azadNormalText: #343434;
$azadDarkText: #131313;
$azadInvertText: #fafafa;
// new for exam ↓↓↓
.bank {
  margin-top: 16px;
  .bankList {
    width: 380px;
    min-height: 312px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 0 16px 0 rgba($color: #000000, $alpha: 0.05),
      0 8px 8px 0 rgba($color: #000000, $alpha: 0.1);
    span.h {
      padding: 16px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.11);
    }
    .filterBox {
      padding: 8px;
    }
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style-type: none;
        padding: 16px;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
        .qindex {
          width: 24px;
          min-width: 24px;
          font-size: 10px;
          font-weight: 300;
          text-align: right;
        }
        .qQuestion {
          span.q {
            font-size: 13px;
            font-weight: 200;
            text-align: right;
          }
          i {
            margin-left: 8px;
            opacity: 0.5;
            transition: all ease-in-out 0.3s;
          }
          i:hover {
            opacity: 1;
          }
          i.hard {
            color: rgb(206, 0, 0);
          }
          i.normal {
            color: rgb(27, 190, 49);
          }
          i.easy {
            color: rgb(54, 101, 161);
          }
        }
        .qAddToList {
          width: 32px;
          min-width: 32px;
          margin-right: 16px;
          i {
            font-size: 16px;
          }
        }
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.05);
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.0);
      }
    }
  }
}
// new for exam ↑↑↑
  .counter{
    min-width: 96px;
    label{
      font-weight: bold;
      margin-right: 8px;
      font-size: 32px;
      color: rgba($color: #363636, $alpha: 1.0);
    }
    span{
      font-weight: 100;
      font-size: 12px;
      color: rgba($color: #363636, $alpha: 1.0);
    }
  }
  .courseInfoHolder {
    $iw: 204px;
    padding: 24px;
    margin-bottom: 24px;
    border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.2);
    img.c{
      width: $iw;
      height: $iw;
      border-radius: 8px;
    }
    .courseTeacher{
      font-size: 16px;
      word-spacing: -2px;
      font-weight: 400;
    }
    .courseLesson{
      font-size: 13px;
      word-spacing: 0px;
      font-weight: 400;
    }
    .courseName{
      font-size: 28px;
      word-spacing: -2px;
      font-weight: 400;
      color: #61187A;
      text-align: right;
      line-height: 1.3;
      border-right: solid 4px rgba($color: #61187A, $alpha: 1);
      padding: 0px 8px 0 0;
    }
  }
  .assignments {
    box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.15);
    border-radius: 8px;
    overflow: hidden;
    .heads {
      width: 100%;
      text-align: right;
      padding: 8px;
      word-spacing: -2px;
      font-size: 14px;
      color: rgba($color: white, $alpha: 1.0);
      font-weight: 400;
      background-color: #61187A;
      i {
        margin-left: 8px;
        font-size: 16px;
        color: #f0f0f0;
        padding: 8px;
      }
    }
    ul {
      padding: 0;
      margin: 0;
      max-height: 400px;
      overflow: hidden auto;
      li {
        width: 100%;
        padding: 12px;
        list-style: none;
        text-align: right;
        span {
          width: 16px;
          font-size: 10px;
          font-weight: 200;
          text-align: right;
        }
        .title {
          font-size: 14px;
          font-weight: bold;
        }
        .desc {
          font-size: 10px;
          font-weight: 300;
        }
      }
    }
  }

  .infos{
    padding: 0 24px;
  }
  .courseId{
    padding: 2px 8px;
    font-size: 10px;
    margin-bottom: 16px;
    letter-spacing: 2px;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }
  .courseSummary{
    padding: 8px 8px 16px;
    font-size: 12px;
    text-align: right;
    color: #646464;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }

  .teacherHolder img.t{
    width: 64px;
    height: 64px;
    margin-left: 8px;
    border-radius: 80px 0 80px 80px;
  }

  .question{
    font-size: 18px;
    font-weight: 300;
    margin-bottom: 16px;
    text-align: right;
  }

  .ltr {
    direction: ltr !important;
  }

  .rules{
    margin: 24px 24px 50px;
  }

  .ruleBox {
    padding: 0 8px;
  }

  .uploadersHolder h3, .videoList h3 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 16px;
    font-weight: 400;
  }
  .uploadersHolder h4, .videoList h4 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 14px;
    font-weight: 200;
    position: relative;
  }

  .uploadersHolder h4::before, .videoList h4::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: royalblue;
    left: calc(100% - 8px);
    top: 50%;
    transform: translateY(-50%);
  }

  .uploadersHolder p, .videoList p {
    width: 100%;
    text-align: right;
    padding: 0px 16px;
    word-spacing: -1px;
    font-size: 12px;
    font-weight: 200;
    margin: 0 0 4px 0;
    position: relative;
  }

  .uploadersHolder p::before, .videoList p::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: rgba(65, 105, 225, 0.301);
    left: calc(100% - 8px);
    top: 5px;
  }

  input[type="text"], input[type='number'] {
    border-radius: 8px;
    border: solid 1px var(--normalText15);
    padding: 4px 8px;
    font-size: 13px !important;
    font-weight: 200 !important;
    width: 100%;
  }

  // n
  .formHead {
    padding: 8px 0px;
    margin-bottom: 8px;
    border-right: solid 2px rgba($color: #000000, $alpha: 0.25);
    i {
      color: blue;
      margin-left: 8px;
    }
    span {
      font-size: 14px;
      font-weight: bold;
      text-align: right;
    }
  }

  .companies {
    .loadingInstitutes {
      border-radius: 24px;
      background-color: rgba($color: #000000, $alpha: 0.015);
      padding: 16px;
      font-size: 16px;
      font-weight: 100;
    }
    .company {
      padding: 8px 8px 8px 16px;
      border-radius: 24px;
      border: solid 2px rgba($color: $azadSecondary, $alpha: 0.25);
      margin: 0 0 4px 4px;
      cursor: pointer;
      * {
        pointer-events: none;
      }
      i {
        margin-left: 8px;
        color: rgba($color: #000000, $alpha: 0.35)
      }
      .companyIcon {
        width: 40px;
        height: 40px;
        margin-left: 8px;
        border-radius: 8px;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      span {
        font-size: 10px;
      }
      .companyName {
        font-weight: bold;
        font-size: 14px;
        line-height: 1;
      }
    }
    .company:hover {
      border: solid 2px rgba($color: $azadSecondary, $alpha: 0.45);
    }
    .company.selected {
      border: solid 2px rgba($color: #419e34, $alpha: 1);
      i {
        margin-left: 8px;
        color: rgba($color: #419e34, $alpha: 0.85);
      }
      .companyIcon {
        background-color: rgba($color: #000000, $alpha: 0.15);
      }
    }
  }
  .consultantHolder {
    input.search {
      outline: 0;
      margin-top: 16px;
      padding: 8px 16px;
      border: solid 1px rgba($color: #000000, $alpha: 0.35);
    }
    padding: 16px;
    .header {
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.25);
      span.t {
        font-size: 14px;
        text-align: right;
        margin-left: 16px;
        color: black;
      }
      .filters {
        span.o {
          font-size: 12px;
          font-weight: bold;
          margin-left: 16px;
        }
        .cheap {
          padding: 4px 8px;
          border-radius: 24px;
          background-color: rgba($color: #000000, $alpha: 0.05);
          font-size: 12px;
          margin-left: 8px;
          cursor: pointer;
        }
        .cheap.selected {
          background-color: rgba($color: #273a64, $alpha: 1);
          box-shadow: 0 12px 12px -12px rgba($color: #000000, $alpha: 1);
          color: white;
        }
      }
    }
    .items {
      max-height: 450px;
      overflow: hidden auto;
      padding: 16px;
      padding-bottom: 8px;
      border-radius: 16px;
      border: solid 2px rgba($color: #000000, $alpha: 0.05);
      .item {
        border-radius: 16px;
        padding: 8px;
        margin-bottom: 8px;
        border: solid 2px rgba($color: #000000, $alpha: 0.05);
        cursor: pointer;
        i.check {
          font-size: 16px;
          margin-left: 4px;
        }
        span.name {
          font-size: 12px;
          font-weight: bold;
          color: #303030;
          text-align: right;
        }
        span.type {
          font-size: 12px;
          font-weight: 200;
          color: #646464;
        }
      }
      .item.gone {
        display: none;
      }
      .item:nth-child(2n+1) {
        background-color: rgba($color: #000000, $alpha: 0.0);
      }
      .item:hover {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      .item.selectedItem {
        border: solid 2px rgba($color: #19b146, $alpha: 0.85) !important;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
    }
    h2 {
      padding: 0;
      margin: 0 0 16px 0;
      font-size: 14px;
      padding-bottom: 16px;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.05);
    }
    .selectedItems {
      padding: 16px;
      border-radius: 16px;
      border: solid 2px rgba($color: #000000, $alpha: 0.05);
      .item {
        border-radius: 24px 8px 8px 24px;
        padding: 4px 8px 4px 4px;
        cursor: pointer;
        span.index {
          margin-left: 4px;
          font-size: 10px;
          text-align: right;
          min-width: 16px;
          width: 16px;
          line-height: 1;
        }
        span.name {
          font-size: 12px;
          font-weight: bold;
          color: #303030;
          text-align: right;
        }
        span.type {
          font-size: 10px;
          font-weight: bold;
          color: #646464;
          white-space: nowrap;
        }
        i.ac {
          font-size: 16px;
          padding: 8px;
          margin-right: 8px;
          border-radius: 50%;
          background-color: rgba($color: #000000, $alpha: 0.05);
        }
        i.ac:hover {
          background-color: rgba($color: #000000, $alpha: 0.15);
        }
      }
      .item:nth-child(2n+1) {
        background-color: rgba($color: #000000, $alpha: 0.02);
      }
    }
    .noResult {
      height: 192px;
      i {
        font-size: 24px;
        color: rgba($color: #000000, $alpha: 0.25);
        margin-bottom: 8px;
      }
      span {
        font-size: 12px;
        width: 80%;
        text-align: center;
      }
      .mini {
        font-size: 12px;
        cursor: pointer;
        margin-top: 16px;
        padding: 4px 8px;
        border-radius: 16px;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      .mini:hover {
        background-color: rgba($color: #000000, $alpha: 0.08);
      }
    }
  }
  .fieldsPreview {
    padding: 16px;
    border-radius: 16px;
    background-color: rgba($color: #000000, $alpha: 0.02);
    .mini {
      font-size: 12px;
      padding-right: 4px;
      margin-bottom: 4px;
    }
    .t {
      font-size: 14px;
      font-weight: bold;
      padding: 4px 8px;
      border-radius: 16px;
      background-color: rgba($color: #000000, $alpha: 0.05);
    }
  }
  .noMoshavers {
    padding: 24px;
    margin: 16px;
    border-radius: 16px;
    background-color: rgba($color: #000000, $alpha: 0.015);
    font-size: 14px;
    i.b {
      font-size: 32px;
      opacity: 0.4;
      margin-bottom: 16px;
    }
  }
  .ti {
    text-align: right;
    font-size: 14px;
    padding-right: 16px;
    margin-bottom: 16px;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.5);
  }
  .sorts {
    .head {
      margin-bottom: 12px;
      i {
        font-size: 20px;
        margin-left: 16px;
        color: var(--normalText8);
      }
      span {
        font-size: 14px;
        font-weight: 300;
        color: var(--normalText);
      }
    }
  }
  .sorts.export {
    padding: 16px;
    border-radius: 16px;
    background-color: var(--normalText05);
  }
</style>
